module.exports = __webpack_public_path__ + "img/thumbnail.c3953f18.jpg";